import angular from 'angular';
angular.module('cloudX').directive('uibSearchRelation', [
  '$compile',
  '$parse',
  'resourceFactorySvc',
  function($compile, $parse, resourceFactorySvc) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true,
      //scope: true,
      link: function(scope, el, attrs) {
        var relationResource = resourceFactorySvc.get('relation');

        el.removeAttr('uib-search-relation'); //Remove own attribute to prevent endless compile loop

        const ignoreAliasGetter = $parse(attrs.ignoreAlias);

        scope.ignoreAlias = ignoreAliasGetter(scope);

        scope.$watch(
          function() {
            return ignoreAliasGetter(scope);
          },
          function(newVal, _) {
            scope.ignoreAlias = newVal;
          },
        );

        el.attr(
          'uib-typeahead',
          'item as (item | relationName:null:null:ignoreAlias | sanitize) for item in $uibSearchCustomer($viewValue)',
        );

        el.attr('id', 'RelationField');
        el.attr('typeahead-select-on-exact', 'true');
        el.attr('typeahead-min-length', '2');
        el.attr(
          'typeahead-template-url',
          'assets/templates/common/directives/uibSearchRelationTemplate.tpl.html',
        );
        el.attr('autocomplete', 'off');
        if (!attrs.placeholder) el.attr('placeholder', "{{'Search relation'|translate}}");

        scope.$uibSearchCustomerRequest = null;
        scope.$uibSearchCustomer = function(searchValue) {
          //Cancel previous request, cancelling a completed request will have no effect
          if (scope.$uibSearchCustomerRequest && scope.$uibSearchCustomerRequest.$cancelRequest)
            scope.$uibSearchCustomerRequest.$cancelRequest();

          var params = {
            take: 20,
            includeInactive: false,
            crmTypes: [],
            type: null,
            forInvoice: false,
          };
          if (attrs.searchOptions) {
            angular.extend(params, $parse(attrs.searchOptions)(scope));
          }
          params.searchValue = searchValue;
          scope.$uibSearchCustomerRequest = relationResource.names(params);
          return scope.$uibSearchCustomerRequest.$promise;
        };
        return $compile(el)(scope);
      },
    };
  },
]);
